import en from './en/translation.json';
import fr from './fr/translation.json';
import de from './de/translation.json';
import es from './es/translation.json';
import pt from './pt/translation.json';
import nl from './nl/translation.json';

const english = {
  translation: en,
  languageName: 'English',
  lang: 'en',
};

const french = {
  translation: fr,
  languageName: 'Français',
  lang: 'fr',
};

const deutsch = {
  translation: de,
  languageName: 'Deutsch',
  lang: 'de',
};

const spanish = {
  translation: es,
  languageName: 'Español',
  lang: 'es',
};

const portuguese = {
  translation: pt,
  languageName: 'Português',
  lang: 'pt',
};

const dutch = {
  translation: nl,
  languageName: 'Dutch',
  lang: 'nl',
};

export { english, french, deutsch, spanish, portuguese, dutch };
